export const MaskType = (type) => {
  if (type === 'date_en') {
    return { format: '####-##-##', placeholder: '____-__-__', mask: '_' };
  } else if (type === 'date_br') {
    return { format: '##/##/####', placeholder: '__/__/____', mask: '_' };
  } else if (type === 'number') {
    return { format: '##########', decimalScale: 0 };
  }
  return undefined;
};